pointerEventConf =
  pointer:
    isTouch: false
    start: "pointerdown"
    move: "pointermove"
    end: "pointerup"
  touch:
    isTouch: true
    start: "touchstart"
    move: "touchmove"
    end: "touchend"
  mouse:
    isTouch: false
    start: "mousedown"
    move: "mousemove"
    end: "mouseup"

deviceType = if "onpointerdown" of window
  "pointer"
else if "ontouchstart" of window
  "touch"
else
  "mouse"

# check if platform is ios based on userAgent 
ios = /iPad|iPhone|iPod/.test(navigator.userAgent) and not window.MSStream
android = /android/i.test(navigator?.userAgent)
# platform will be null when the document into which it's embedded has a different origin.
platform = window.frameElement?.dataset?.platform

module.exports =
  dpi: window.devicePixelRatio or 1
  isIE: ->
    document.documentMode or /Edge/.test(navigator?.userAgent or "")
  # device.coffee will get called early in the stage before the global script from thomas script is injected
  # which causing window.__?.slidedeck to always be undefined at this stage
  platform:
    window.__?.slidedeck?.platform or
    platform or
    (ios and "iOS") or
    (android and "Android") or
    "browser"

  events:
    pointer: pointerEventConf[deviceType]

    resize: "resize"

  breakpoint: (sizes) ->
    sizes = [sizes] if typeof sizes is "string"
    point =
      if      window.innerWidth <= 600   then "xs"
      else if window.innerWidth <= 768   then "sm"
      else if window.innerWidth <= 1024  then "md"
      else "lg"

    if sizes then _.include(sizes, point) else point
